import { Radio } from "@mui/material";
import React from "react";
import { FlatList, StyleSheet, Text, TouchableOpacity } from "react-native";
import EmptyListCompnoent from "../../../../common/component/EmptyListComponent";
import { THEME_COLORS } from "../../../../common/themes";

function WorkshopListing({ data, selected, selectWorkshopId, actualWorkshopId }) {
  const renderItem = ({ item }) => {
    const currentAssignedWorkshopSelected = actualWorkshopId === item.id;
    return (
      <TouchableOpacity
        activeOpacity={0.8}
        disabled={currentAssignedWorkshopSelected}
        style={[
          styles.container,
          selected === item.id && styles.selected,
          { opacity: currentAssignedWorkshopSelected ? 0.4 : 1 },
        ]}
        onPress={() => selectWorkshopId(item.id)}
      >
        <Radio color="primary" checked={selected === item.id} />
        <Text>{item.displayName}</Text>
      </TouchableOpacity>
    );
  };

  return (
    <FlatList
      style={{ height: "65%" }}
      data={data}
      keyExtractor={(item) => item.id}
      renderItem={renderItem}
      ListEmptyComponent={() => <EmptyListCompnoent emptyListText={"No Workshop is available to assign"} />}
    />
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    padding: "0.5em",
    paddingLeft: "0.8em",
    border: `1px solid ${THEME_COLORS.grey1}`,
    borderRadius: 5,
    marginVertical: 8,
  },
  selected: {
    backgroundColor: THEME_COLORS.sideMenuBg,
    border: "1px solid transparent",
  },
});

export default WorkshopListing;
